import React from 'react';
import { createGlobalStyle } from 'styled-components';
import Header from './components/Header';
import Hero from './components/Hero';
import VideoSection from './components/VideoSection';
import Features from './components/Features';
import TestimonialsCarousel from './components/TestimonialsCarousel';
import NotificationBubble from './components/NotificationBubble';
import CarCursor from './components/CarCursor';
import Footer from './components/Footer';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif;
  }
  
  body {
    background-color: #0a1a1f;
    color: white;
    overflow-x: hidden;
  }
  
  html {
    scroll-behavior: smooth;
  }
`;

function App() {
  return (
    <>
      <GlobalStyle />
      <Header />
      <Hero />
      <VideoSection />
      <Features />
      <TestimonialsCarousel />
      <Footer />
      <NotificationBubble />
      <CarCursor />
    </>
  );
}

export default App;
